<template>
    <el-table :data="tableData" border style="width: 100%">
        <el-table-column
            label="序号"
            align="center"
            width="50"
            type="index"
        ></el-table-column>
        <el-table-column
            v-for="(item, index) in data.columnList"
            :key="index"
            :label="item.label"
            :prop="item.prop"
            align="center"
        >
            <template #default="scope" v-if="item.prop === 'userType'">
                {{ userTypeInfo[scope.row.userType] || "" }}
            </template>
            <template #default="scope" v-else-if="item.prop === 'paymentMethod'">
                {{ scope.row.paymentMethod == 1 ? "充值" : "消费" }}
            </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
            <template #default="scope">
                <el-button
                    type="primary"
                    size="mini"
                    @click="handleEdit(scope.row)"
                >编辑</el-button
                >
                <el-button
                    type="primary"
                    size="mini"
                    @click="handleDelete(scope.row)"
                >删除</el-button
                >
            </template>
        </el-table-column>
    </el-table>
    <!-- 审核 -->
    <audit-user ref="AuditUserRef" :currentData="data.currentData"></audit-user>
    <!-- 修改 用户信息 -->
    <add-edit-user
        ref="AddEditUserRef"
        scene="edit"
        :currentData="data.currentData"
    ></add-edit-user>
</template>

<script>
import { reactive } from "@vue/reactivity";
import { inject, ref } from "vue";
import AuditUser from "./children/audit-user.vue";
import AddEditUser from "./children/add-edit-user.vue";
import ElementPlus, {ElMessage, ElMessageBox} from "element-plus";
import {rechargeConfigDelete} from "@/api/recharge";
export default {
    props: {
        tableData: Array,
    },
    components: {
        AuditUser,
        AddEditUser,
    },
    setup() {
        const userTypeInfo = inject("userTypeInfo");
        const AddEditUserRef = ref(null);
        const AuditUserRef = ref(null);
        const handleUpdateTable = inject("handleUpdateTable");
        const data = reactive({
            currentData: {},
            columnList: [
                {
                    label: "ID",
                    prop: "id",
                },
                {
                    label: "充值金额",
                    prop: "rechargeAmount",
                },
                {
                    label: "赠送金额",
                    prop: "giftAmount",
                }
            ],
        });

        const handleEdit = (val) => {
            data.currentData = val;
            AddEditUserRef.value.handleToggle(true);
        };
        const handleDelete = (val) => {
            try {
                // 删除确认
                ElMessageBox.confirm("是否删除该配置？","提示",{
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    const params = {
                        id: val.id,
                    };
                    rechargeConfigDelete(params).then((res) => {
                        if (res.code === 200) {
                            ElMessage.success("删除成功");
                        }
                    })
                    handleUpdateTable();
                });
            }catch (e) {
                console.error(e)
            }
        };
        const handleAudit = (val) => {
            data.currentData = val;
            AuditUserRef.value.handleToggle(true);
        };
        return {
            AddEditUserRef,
            AuditUserRef,
            handleAudit,
            handleEdit,
            handleDelete,
            data,
            userTypeInfo,
        };
    },
};
</script>

<style  scoped>
</style>
